import { hMacAjax } from 'grt-tool-lib-front';
import { baseURL } from '@/httpService/API';

// const baseUserURL = `${baseURL}/grt-user-service`;
const mallUserServiceURL = `${baseURL}/grt-trade-service/user`;
let url = {
    create: '/tdRefund/create',
    detail: '/tdRefund/',
    config: '/tdRefundConfig/findAll'
};

//创建退款
export const createRefund = (data) => {
    return hMacAjax.post(mallUserServiceURL + url.create, data);
};
//退款详情
export const getRefundDetail = (id) => {
    return hMacAjax.get(mallUserServiceURL + url.detail + id);
};
export const getRefundReason = (data) => {
    return hMacAjax.post(mallUserServiceURL + url.config, data);
};
